import { Info } from '@phosphor-icons/react';
import { Label } from '@/components/ui/label';
import { SimpleDropdown } from '@/components/ui/simple-dropdown';
import type { AnswerOptionCondition } from 'shared/types/due-diligence';

interface LinkedLabel {
  id: number;
  name: string;
}

interface FileExistsEditorProps {
  condition: AnswerOptionCondition;
  onUpdate: (updates: Partial<AnswerOptionCondition>) => void;
  linkedLabels?: LinkedLabel[];
}

export function FileExistsEditor({ condition, onUpdate, linkedLabels }: FileExistsEditorProps) {
  const options = [
    { value: 'true', label: 'Bestand BESTAAT' },
    { value: 'false', label: 'Bestand BESTAAT NIET' },
  ];

  const currentValue = condition.fileExists === true ? 'true' : 'false';

  const selectedLabel = linkedLabels?.find((l) => l.id === condition.labelId);
  const labelNames = linkedLabels?.map((l) => l.name) || [];

  return (
    <div className="space-y-4">
      {/* Label context info */}
      {linkedLabels && linkedLabels.length > 0 && (
        <div className="flex items-start gap-2 text-sm bg-blue-50 dark:bg-blue-950/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
          <Info className="h-4 w-4 text-blue-500 mt-0.5 shrink-0" />
          <div>
            {condition.labelId && selectedLabel ? (
              <p>
                Wordt gecontroleerd voor label:{' '}
                <span className="font-semibold">{selectedLabel.name}</span>
              </p>
            ) : (
              <p>
                Wordt gecontroleerd voor alle gekoppelde labels:{' '}
                <span className="font-semibold">{labelNames.join(', ')}</span>
              </p>
            )}
          </div>
        </div>
      )}

      <div className="space-y-2">
        <Label className="text-sm font-medium">Bestaan van bestand</Label>
        <SimpleDropdown
          value={currentValue}
          onChange={(value) => onUpdate({ fileExists: value === 'true' })}
          options={options}
          placeholder="Selecteer conditie..."
        />
      </div>
      <div className="text-sm text-muted-foreground bg-muted/30 p-3 rounded-lg border border-border">
        <p className="font-medium mb-1">Uitleg:</p>
        <p>
          {currentValue === 'true'
            ? 'Deze conditie is waar wanneer er minstens één bestand is geüpload met het gelinkte label.'
            : 'Deze conditie is waar wanneer er geen bestanden zijn geüpload met het gelinkte label.'}
        </p>
      </div>
    </div>
  );
}
